// @flow
import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent';
import ApiObjectSuggestField from './../field/ApiObjectSuggestField';
import EoApi from './../api/EoApi';
import {COMPONENT_CHILDREN} from './../Utils2';

/**
 * Field pro fulltextové hledání pracovníků.
 */
class PracovnikField extends AbstractReactComponent {

    static PropTypes = {
        proSpustenouAplikaci: React.PropTypes.bool, // pokud je true, hledá jen mezi pracovníky aktuýálně spuštěné aplikace, jinak hledá mezi všemi pracovníky
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
        apiRequestDelay: React.PropTypes.number
    };

    static defaultProps = {
        apiRequestDelay: 250,
        proSpustenouAplikaci: true
    };

    handleFilterSuggestions = (value) => {
        const {proSpustenouAplikaci} = this.props;
        return EoApi.findPracovnici(value, proSpustenouAplikaci, 100);
    };

    renderPracovnik = (i, active, getItemValue) => {
        return <div className={active ? "active" : ""}>
            {i.uplneJmeno}
            {i.organizacniJednotka && <small> ({i.organizacniJednotka.nazev})</small>}
        </div>
    };

    render() {
        const {...other} = this.props;

        return <ApiObjectSuggestField
            minCharsForFilter={3}
            placeholder="Vyhledat pracovníka..."
            filterSuggestions={this.handleFilterSuggestions}
            getItemValue={(item) => item ? item.uplneJmeno : ""}
            renderSuggestion={this.renderPracovnik}
            {...other}
        />
    }
}
export default PracovnikField;
